"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/CVFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_54)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_54`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M-1.20001 0H34.8V24H-1.20001V0Z",
					fill: "#003893"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-1.20001 12.7859H34.8V15.6912H-1.20001V12.7859Z",
					fill: "#CF2027"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-1.20001 9.88071H34.8V12.786H-1.20001V9.88071ZM-1.20001 15.6912H34.8V18.5965H-1.20001V15.6912Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M9.35436 4.91229L9.83858 6.39299H11.3965L10.1333 7.31229L10.6175 8.79299L9.35436 7.8737L8.09822 8.79299L8.57542 7.31229L7.31928 6.39299H8.87717L9.35436 4.91229ZM9.35436 19.6281L9.83858 21.1088H11.3965L10.1333 22.0211L10.6175 23.5088L9.35436 22.5895L8.09822 23.5088L8.57542 22.0211L7.31928 21.1088H8.87717L9.35436 19.6281ZM2.50524 14.6526L2.98945 16.1333H4.54735L3.28419 17.0456L3.7684 18.5333L2.50524 17.614L1.2491 18.5333L1.72629 17.0456L0.470154 16.1333H2.02805L2.50524 14.6526ZM5.12279 6.38598L5.607 7.86668H7.16489L5.90173 8.77896L6.38594 10.2667L5.12279 9.34738L3.86664 10.2667L4.34384 8.77896L3.08068 7.86668H4.64559L5.12279 6.38598ZM0.470154 11.3684H2.02805L2.50524 9.88773L2.98945 11.3684H4.54735L3.28419 12.2877L3.7684 13.7684L2.50524 12.8562L1.2491 13.7684L1.72629 12.2877L0.470154 11.3684ZM3.86664 21.8176L4.34384 20.3369L3.08068 19.4246H4.64559L5.12279 17.9369L5.607 19.4246H7.16489L5.90173 20.3369L6.38594 21.8176L5.12279 20.9053L3.86664 21.8176ZM16.2035 14.6526L15.7193 16.1333H14.1614L15.4245 17.0456L14.9403 18.5333L16.2035 17.614L17.4666 18.5333L16.9824 17.0456L18.2456 16.1333H16.6877L16.2035 14.6526ZM13.5859 6.38598L13.1087 7.86668H11.5509L12.807 8.77896L12.3298 10.2667L13.5859 9.34738L14.8491 10.2667L14.3649 8.77896L15.628 7.86668H14.0702L13.5859 6.38598ZM18.2456 11.3684H16.6877L16.2035 9.88773L15.7193 11.3684H14.1614L15.4245 12.2877L14.9403 13.7684L16.2035 12.8562L17.4666 13.7684L16.9824 12.2877L18.2456 11.3684ZM14.8491 21.8176L14.3649 20.3369L15.628 19.4246H14.0702L13.5859 17.9369L13.1087 19.4246H11.5509L12.807 20.3369L12.3298 21.8176L13.5859 20.9053L14.8491 21.8176Z",
					fill: "#F7D116",
					stroke: "black",
					strokeWidth: .0701754
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_54`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as CVFlag };
